module.exports = __webpack_public_path__ + "images/payment_terms.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/payment_terms.png
// module id = 4mHr
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13